import { NgModule } from '@angular/core';
import { NumberTranslatePipe } from './number-translate.pipe';

@NgModule({
  imports: [],
  declarations: [NumberTranslatePipe],
  exports: [NumberTranslatePipe],
})
export class NumberTranslatePipeModule {}
